import { RoleAccess } from "../../hooks/auth/types";
import { GenderEnum, Role } from "../../models";
import {
  CommitteeDecision,
  CommitteeEnrollmentDecision,
  RequestStatus,
  RequestType,
  Request,
  PersonDetails,
  Form7,
  RequestRemark,
} from "../../models/Request";

export const REQUEST_DETAILS_ADMIN_ACCESS: RoleAccess = {
  whitelist: [
    Role.CAS,
    Role.Helpdesk,
    Role.CountyAdministrator,
    Role.CountyLeader,
  ],
};
export const REQUEST_DETAILS_INSTITUTION_ACCESS: RoleAccess = {
  whitelist: [
    Role.CAS,
    Role.Helpdesk,
    Role.InstitutionAdministrator,
    Role.InstitutionPrincipal,
  ],
};

export const REQUEST_DETAILS_COUNTY_ACCESS: RoleAccess = {
  whitelist: [
    Role.CAS,
    Role.Helpdesk,
    Role.CountyAdministrator,
    Role.CountyLeader,
  ],
};

export const REQUEST_DETAILS_RETURN_TO_ACCESS: RoleAccess = {
  whitelist: [
    Role.CAS,
    Role.Helpdesk,
  ],
};

export const PROCEDURE_SUBMITTED_STATUSES = [
  RequestStatus.ProcedureSubmitted,
  RequestStatus.OnSchoolCandidateList,
  RequestStatus.Cancelled,
];

export const ENROLLMENT_INSTITUTION_STATUSES = [
  RequestStatus.EnrollmentConfirmed,
  RequestStatus.RegistrationFormCreating,
  RequestStatus.RegistrationFormCreated,
  RequestStatus.Registered,
];

export const RETURN_TO_SUBMITTED_STATUSES = [
  RequestStatus.ProcedureSubmitted,
  RequestStatus.Submitted,
  RequestStatus.Draft,
  RequestStatus.RegistrationFormCreating,
];

export const RETURN_TO_PROCEDURE_STATUSES = [
  RequestStatus.Cancelled,
  RequestStatus.ProcedureApproved,
  RequestStatus.ProcedureRejected,
  RequestStatus.OnSchoolCandidateList,
];

export const DEFAULT_COMMITTEE_DECISION: CommitteeDecision = {
  id: 0,
  requestId: 0,
  committeeEmployeeId: 0,
  committeeEnrollmentDecisionId: CommitteeEnrollmentDecision.Ready,
  updatedDate: new Date(),
  dateCreated: new Date(),
  hasDecisionsInPreviousInstitutionCommittees: null,
  hasDecisionsInPreviousCountyCommittees: null,
};

export const DEFAULT_REQUEST: Request = {
  id: 0,
  requestUID: "",
  code: "",
  statusId: RequestStatus.Draft,
  schoolYearId: 0,
  type: RequestType.RegularEnrollment,
  createdByAdmin: true,
  isOutsideEnrollmentArea: false,
  step: 0,
  subStep: null,
  parentRemark: null,
  otherParentDetails: null,
  schoolYearCode: null,
  institutionProgramId: null,
  institutionProgram: null,
  institutionId: undefined,
  commercialProgramId: null,
  outsideEnrollmentAreaInstitutionProgramId: null,
  outsideEnrollmentAreaInstitutionProgram: null,
  institutionChangeReason: null,
  institutionChangeReasonOther: null,
  createdByAppUserId: null,
  outsideEnrollmentAreaCommercialProgramId: null,
  schoolCandidateId: undefined,
  institutionCommitteeId: undefined,
  countyCommitteeId: undefined,
  countyId: undefined,
  mandatoryForeignLanguages: null,
  electiveSubjects: null,
  languageSchoolingModels: null,
  foreignLanguages: null,
  questionnaire: null,
  questionnaireAnswers: [],
  childUploadFiles: null,
  childAttachments: null,
  educationalRehabilitationUploadFiles: null,
  educationalRehabilitationAttachments: null,
  medicalUploadFiles: null,
  medicalAttachments: null,
  otherUploadFiles: null,
  otherAttachments: null,
  parentUploadFiles: null,
  parentAttachments: null,
  psychologyUploadFiles: null,
  psychologyAttachments: null,
  psychophysicalConditionDecisionUploadFiles: null,
  psychophysicalConditionDecisionAttachments: null,
  uniqueBodyOfExpertiseUploadFiles: null,
  uniqueBodyOfExpertiseAttachments: null,
  subsequentUploadFiles: null,
  subsequentAttachments: null,
  suggestedEnrollmentOutsideEnrollmentArea: undefined,
  approvedEnrollmentOutsideEnrollmentArea: undefined,
  outsideEnrollmentAreaStatus: null,
  languageCourseDecisionStatus: null,
  enrollmentInstitutionId: null,
  synchronizationStatus: undefined,
  applicantParent: undefined,
  applicantParentDetails: undefined,
  child: undefined,
  childDetails: undefined,
  statusHistory: null,
  remarks: [],
  registrationFormDataChangeId: null,
  parentCountyId: null,
};

export const DEFAULT_PERSON_DETAILS: PersonDetails = {
  id: 0,
  personId: 0,
  person: {
    alternativeDocumentNumber: "",
    alternativeDocumentTypeId: 0,
    alternativeDocumentReasonId: 0,
    isEmpty: false,
    id: 0,
  },
  firstName: "",
  lastName: "",
  dateOfBirth: new Date(),
  genderId: GenderEnum.Male,
  nationalMinorityId: null,
  parentshipTypeId: null,
  parentNumberId: null,
  custody: null,
  professionName: null,
  professionalQualificationId: null,
  residence: undefined,
  contactMethodId: null,
  qualificationName: null,
};

export const DEFAULT_FORM7 = (requestId: number): Form7 => ({
  id: 0,
  requestId: requestId,
  sessionDate: new Date(),
  isEarlyEnrollmentApproved: false,
  isEarlyEnrollmentRejected: false,
  isEnrollmentPostponement: false,
  isTemporaryExemptionApproved: false,
  isTemporaryExemptionRejected: false,
  isAppropriateProgram: false,
  isPreparatoryCourse: false,
  hasDifficulties: false,
  request: DEFAULT_REQUEST,
  committeesForDocument: [],
});

export const DEFAULT_REQUEST_REMARK: RequestRemark = {
  id: 0,
  requestId: 0,
  remark: "",
  requestRemarkTypeId: 0,
};

export const INSTITUTION_CHANGE_REASON_OTHER_MAX_LENGTH = 1000;